import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-estudos-trademkt',
  templateUrl: './estudos-trademkt.component.html',
  styleUrls: ['./estudos-trademkt.component.css']
})
export class EstudosTrademktComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
